<div [class.bg-violet-100]="aside$ | async" [class.dark:bg-[#252c5f]]="aside$ | async">

    <div class="w-full">

      <div class="mx-auto lg:mx-0 lg:max-w-none flex items-center justify-between border-b border-violet-200/50 p-6">
        <h2 class="text-lg text-secondary dark:text-white font-semibold">Vault - Personal Notes</h2>
        <button type="button" (click)="closeAside()" class="hover:opacity-90">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="size-5 text-secondary">
            <path d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
          </svg>
        </button>
      </div>

        <!-- Notes -->
        <div @fadeFromRight class="space-y-3 pt-6 px-3 pb-3 overflow-y-scroll h-[calc(100vh-225px)]
          scrollbar-thin scrollbar-track-transparent scrollbar-thumb-violet-200 hover:scrollbar-thumb-transparent">

          <div>
            <p class="text-xs italic text-secondary">This is your vault, all you store in this section is private.</p>
          </div>

          <!-- Summary Note -->
          <div class="" [ngClass]="this.total_notes < 5 ? 'hidden' : ''">
            <div class="bg-violet-50 dark:bg-[#1e2451] p-3 rounded-md w-full max-h-40 overflow-y-auto">
              <div class="mx-auto flex justify-start items-center space-x-2 mb-1">

                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor" aria-hidden="true" data-slot="icon" class="size-4 fill-violet-500">
                  <path fill-rule="evenodd" d="M5 4a.75.75 0 0 1 .738.616l.252 1.388A1.25 1.25 0 0 0 6.996 7.01l1.388.252a.75.75 0 0 1 0 1.476l-1.388.252A1.25 1.25 0 0 0 5.99 9.996l-.252 1.388a.75.75 0 0 1-1.476 0L4.01 9.996A1.25 1.25 0 0 0 3.004 8.99l-1.388-.252a.75.75 0 0 1 0-1.476l1.388-.252A1.25 1.25 0 0 0 4.01 6.004l.252-1.388A.75.75 0 0 1 5 4ZM12 1a.75.75 0 0 1 .721.544l.195.682c.118.415.443.74.858.858l.682.195a.75.75 0 0 1 0 1.442l-.682.195a1.25 1.25 0 0 0-.858.858l-.195.682a.75.75 0 0 1-1.442 0l-.195-.682a1.25 1.25 0 0 0-.858-.858l-.682-.195a.75.75 0 0 1 0-1.442l.682-.195a1.25 1.25 0 0 0 .858-.858l.195-.682A.75.75 0 0 1 12 1ZM10 11a.75.75 0 0 1 .728.568.968.968 0 0 0 .704.704.75.75 0 0 1 0 1.456.968.968 0 0 0-.704.704.75.75 0 0 1-1.456 0 .968.968 0 0 0-.704-.704.75.75 0 0 1 0-1.456.968.968 0 0 0 .704-.704A.75.75 0 0 1 10 11Z" clip-rule="evenodd"></path>
                </svg>

                <h4 class="text-sm text-secondary dark:text-white text-start font-semibold">Summary of my notes</h4>
              </div>

              <div class="flex justify-start text-left">
              <span *ngIf="isLoadedSummary && notes_summary" @fadeIn class="text-sm text-[#3c4377] dark:text-primary-200 font-light">
                {{notes_summary.summary}}
              </span>
                <div [ngClass]="(isLoadedSummary && notes_summary) ? 'hidden' : ''" class="text-sm text-[#3c4377] dark:text-primary-200">
                  Loading...
                </div>
              </div>
            </div>
          </div>

            <!-- Note -->
            <div *ngFor="let note of notes; index as i;"  class="bg-violet-50 rounded-md px-3">

                <div class="flex justify-between items-center pt-3 mb-1">
                    <span class="text-sm font-semibold text-secondary">
                        {{formatDate(note['created_at'])}}
                    </span>
                    <div class="flex gap-2">
                      <!-- Edit-->
                      <button type="button" [ngClass]="this.edit_note[i] ? 'hidden' : ''" (click)="toggleEditNote(i)" class="text-secondary hover:opacity-90 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-none">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="size-4">
                          <path d="m2.695 14.762-1.262 3.155a.5.5 0 0 0 .65.65l3.155-1.262a4 4 0 0 0 1.343-.886L17.5 5.501a2.121 2.121 0 0 0-3-3L3.58 13.419a4 4 0 0 0-.885 1.343Z" />
                        </svg>
                      </button>

                      <!-- Save -->
                      <button type="button" [ngClass]="!this.edit_note[i] ? 'hidden' : ''" (click)="editNote(note,edited_note_text);toggleEditNoteFinish(i)" class="text-secondary hover:opacity-90 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-none">
                        <span class="bg-secondary text-white py-0.5 px-2 rounded-full text-xs">Save</span>
                      </button>

                      <!-- Delete-->
                      <button type="button" [ngClass]="this.edit_note[i] ? 'hidden' : ''" (click)="deleteNotePopUp(note)" class="text-secondary hover:opacity-90 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-none">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="size-4">
                          <path fill-rule="evenodd" d="M8.75 1A2.75 2.75 0 0 0 6 3.75v.443c-.795.077-1.584.176-2.365.298a.75.75 0 1 0 .23 1.482l.149-.022.841 10.518A2.75 2.75 0 0 0 7.596 19h4.807a2.75 2.75 0 0 0 2.742-2.53l.841-10.52.149.023a.75.75 0 0 0 .23-1.482A41.03 41.03 0 0 0 14 4.193V3.75A2.75 2.75 0 0 0 11.25 1h-2.5ZM10 4c.84 0 1.673.025 2.5.075V3.75c0-.69-.56-1.25-1.25-1.25h-2.5c-.69 0-1.25.56-1.25 1.25v.325C8.327 4.025 9.16 4 10 4ZM8.58 7.72a.75.75 0 0 0-1.5.06l.3 7.5a.75.75 0 1 0 1.5-.06l-.3-7.5Zm4.34.06a.75.75 0 1 0-1.5-.06l-.3 7.5a.75.75 0 1 0 1.5.06l.3-7.5Z" clip-rule="evenodd" />
                        </svg>
                      </button>
                  </div>
                </div>

                <div class="flex pb-3">
                    <div class="w-full">
                      <p [ngClass]="this.edit_note[i] ? 'hidden' : '' " class="text-sm text-secondary">{{ note['content']}}</p>
                      <textarea rows="5" [ngClass]="!this.edit_note[i] ? 'hidden' : '' "  [(ngModel)]="edited_note_text" maxlength="250" [defaultValue]="note['content']" type="text" class="text-sm p-2 focus:border-primary w-full dark:bg-white rounded-md bg-white border-none focus-visible:ring-transparent focus-visible:outline-none"></textarea>
                    </div>
                </div>

            </div>
            <div [ngClass]="!show_more_notes ? 'hidden' : ''" class="flex items-center">
              <span (click)="showMoreNotes()" class="cursor-pointer  text-xs font-normal text-violet-500 hover:opacity-90">
                Show More
              </span>
            </div>

        </div>

      <!-- / Notes -->

    </div>

    <!-- Footer -->
    <div class="sticky bottom-0 w-full p-3">
        <!-- Input -->
        <div class="flex items-center bg-white dark:bg-[#252c5f] rounded-md w-full">
            <!-- Attach Button -->
            <!--
            <button class="p-3 pr-0 text-gray-500 dark:text-[#bcc3ff]">
                <svg class="h-4 w-4" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                    <path fill-rule="evenodd" d="M15.621 4.379a3 3 0 00-4.242 0l-7 7a3 3 0 004.241 4.243h.001l.497-.5a.75.75 0 011.064 1.057l-.498.501-.002.002a4.5 4.5 0 01-6.364-6.364l7-7a4.5 4.5 0 016.368 6.36l-3.455 3.553A2.625 2.625 0 119.52 9.52l3.45-3.451a.75.75 0 111.061 1.06l-3.45 3.451a1.125 1.125 0 001.587 1.595l3.454-3.553a3 3 0 000-4.242z" clip-rule="evenodd" />
                </svg>
                <span class="sr-only">Attach a file</span>
            </button>
            -->

            <!-- Input Field -->
            <input type="text" [(ngModel)]="note" maxlength="250" (keydown.enter)="addNote()" [disabled]="!isLoadedNotes" class="flex-1 items-center p-3 border-none focus:ring-0 text-sm text-secondary placeholder:text-sm placeholder-gray-400 dark:bg-[#252c5f] dark:placeholder-[bcc3ff] rounded-md" placeholder="Write new note">

            <!-- Send Button -->
            <button (click)="addNote()" [disabled]="!isLoadedNotes || !note || note.trim().length === 0"  class="bg-transparent hover:opacity-75 p-3 disabled:opacity-75">
                <svg  viewBox="0 0 16 18" class="w-4 h-4 fill-[#fc8125]" fill="none">
                    <path d="M15.3306 8.11622L1.46789 0.777129C0.801887 0.42454 0 0.907342 0 1.66092V6.23173C0 6.68478 0.304584 7.08123 0.742337 7.19797L7.5 9.00001L0.742338 10.8021C0.304584 10.9188 0 11.3152 0 11.7683V16.3391C0 17.0927 0.801886 17.5755 1.46789 17.2229L15.3306 9.8838C16.0401 9.50819 16.0401 8.49183 15.3306 8.11622Z" />
                </svg>
                <span class="sr-only">Send message</span>
            </button>
        </div>
        <!-- / Input -->

    </div>
    <!-- / Footer -->

</div>
